module.exports = __webpack_public_path__ + "img/08.710fbf82.jpg";